import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { ReactComponent as LocationIcon } from '../../assets/icons/location.svg';
import styles from './LocationInput.module.scss';
const LocationInput = ({ className, value, onChange, onFocus, onBlur }) => {
    return (_jsx("div", Object.assign({ className: cn(styles.wrapper, className) }, { children: _jsxs("div", Object.assign({ className: cn('d-flex align-items-center', styles.element) }, { children: [_jsx("input", { placeholder: 'Select', onChange: onChange, onFocus: onFocus, onBlur: onBlur, value: value }), _jsx(LocationIcon, {})] })) })));
};
export default LocationInput;
